import { jsPDF } from 'jspdf'
import autoTable from 'jspdf-autotable'
import UbuntuBase64 from '../assets/fonts/UbuntuBase64'
import UbuntuBoldBase64 from '../assets/fonts/UbuntuBoldBase64'
import logoImg from '../assets/images/logo-raudo.png'
import symbolyImg from '../assets/images/symboly.png'
import razitkoImg from '../assets/images/razitko-raudo.jpg'
import bannerPremioImg from '../assets/images/banner-premio.jpg'
import energyFuelImg from '../assets/images/energy-fuel.svg'
import energyWetImg from '../assets/images/energy-wet.svg'
import energyNoiseImg from '../assets/images/energy-noise.svg'
import { fetchProdejkaPohyb } from '../services/api/objednavky'

const imageDataUrlCache = new Map()

const toNum = (value) => {
  if (value === null || value === undefined || value === '') return 0
  const n = Number(String(value).replace(',', '.').trim())
  return Number.isFinite(n) ? n : 0
}
const toTrim = (value) => String(value ?? '').trim()
const toBase64Payload = (asset) => {
  const str = String(asset || '')
  const idx = str.indexOf(',')
  return idx >= 0 ? str.slice(idx + 1) : str
}
const guessImageFormat = (dataUrl) => (String(dataUrl || '').startsWith('data:image/png') ? 'PNG' : 'JPEG')
const fileUrlToDataUrl = async (url) => {
  if (!url) return ''
  if (imageDataUrlCache.has(url)) return imageDataUrlCache.get(url)
  const response = await fetch(url)
  if (!response.ok) throw new Error(`Nepodařilo se načíst obrázek: ${url}`)
  const blob = await response.blob()
  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(String(reader.result || ''))
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
  imageDataUrlCache.set(url, dataUrl)
  return dataUrl
}
const ensurePdfImageDataUrl = async (dataUrl) => {
  if (!String(dataUrl || '').startsWith('data:image/svg+xml')) return dataUrl
  if (typeof document === 'undefined') return ''
  const img = await new Promise((resolve, reject) => {
    const image = new Image()
    image.onload = () => resolve(image)
    image.onerror = reject
    image.src = dataUrl
  })
  const canvas = document.createElement('canvas')
  canvas.width = img.width || 48
  canvas.height = img.height || 48
  const ctx = canvas.getContext('2d')
  if (!ctx) return ''
  ctx.drawImage(img, 0, 0)
  return canvas.toDataURL('image/png')
}
const formatDate = (value) => {
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleDateString('cs-CZ', { year: 'numeric', month: '2-digit', day: '2-digit' })
}
const formatQty = (value) =>
  toNum(value).toLocaleString('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const formatMoney = (value) =>
  toNum(value).toLocaleString('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const formatPercent = (value) =>
  toNum(value).toLocaleString('cs-CZ', { minimumFractionDigits: 0, maximumFractionDigits: 2 })

const printSale = async (order) => {
  const cisloObjed = String(order?.cislo || '').trim()
  if (!cisloObjed) {
    throw new Error('Chybí číslo objednávky.')
  }

  const detail = await fetchProdejkaPohyb(cisloObjed)
  const rawHeader = detail?.header || {}
  const rawItems = Array.isArray(detail?.items) ? detail.items : []

  const header = {
    SKLAD: rawHeader.SKLAD,
    CISLOPOH: rawHeader.CISLOPOH,
    STREDISKO: rawHeader.STREDISKO,
    CISLOOBJED: rawHeader.CISLOOBJED,
    ORIGCISLO: rawHeader.ORIGCISLO,
    ZAKAZKA: rawHeader.ZAKAZKA,
    SPZ: rawHeader.USRFLD1,
    POZNAMKA: rawHeader.POZNAMKA,
    DATUM: rawHeader.DATUM,
    CIASTKA: toNum(rawHeader.CIASTKA),
    DPH: toNum(rawHeader.DPH),
    CELKOM: toNum(rawHeader.CELKOM),
    ZAKL0: rawHeader.ZAKL0,
    ZAKL1: rawHeader.ZAKL1,
    ZAKL2: rawHeader.ZAKL2,
    DPH1: rawHeader.DPH1,
    DPH2: rawHeader.DPH2,
    ICO: rawHeader.ICO,
    FIRMA: rawHeader.FIRMA,
    FIRMA2: rawHeader.FIRMA2,
    MENO: rawHeader.MENO,
    ULICA: rawHeader.ULICA,
    PSC: rawHeader.PSC,
    MESTO: rawHeader.MESTO,
    DIC: rawHeader.DIC,
    STAT: rawHeader.STAT,
    TELEFON: rawHeader.TELEFON,
    EMAIL: rawHeader.EMAIL,
    ICOPRIJ: rawHeader.ICOPRIJ,
    KPFIRMA: rawHeader.KPFIRMA,
    KPFIRMA2: rawHeader.KPFIRMA2,
    KPMENO: rawHeader.KPMENO,
    KPULICA: rawHeader.KPULICA,
    KPPSC: rawHeader.KPPSC,
    KPMESTO: rawHeader.KPMESTO,
    KPDIC: rawHeader.KPDIC,
    KPSTAT: rawHeader.KPSTAT,
    KPTELEFON: rawHeader.KPTELEFON,
    KPEMAIL: rawHeader.KPEMAIL    
  }

  const items = rawItems.map((item) => ({
    TYP_RADKU: 1,
    CISLO: item.CISLOKAR,
    NAZEV: item.NAZEV,
    MJ: item.MJ,    
    KOD1: item.KOD1,
    RECYKLKOD: item.RECYKLKOD, // REC11 
    PRISPEVEK: 5.26, // příspěvek na recyklaci 5,26Kč/kg
    HMOTNOST: item.HMOTNOST,
    USRFLD1: item.USRFLD1, // palivo
    USRFLD2: item.USRFLD2, // přilnavost
    USRFLD3: item.USRFLD3, // hluk
    POCETMJ: item.POCETMJ,    
    CENAMJ: item.CENAMJ, 
    CENA_MJ: item.CENA_MJ, // po slevě
    ZLAVA: item.ZLAVA,
    SLEVAMJ: item.SLEVAMJ,
    SADZBADPH: item.SADZBADPH,
  }))

  const zaklad = toNum(header.ZAKL0) + toNum(header.ZAKL1) + toNum(header.ZAKL2)
  const dph = toNum(header.DPH1) + toNum(header.DPH2)
  const celkem = toNum(header.CELKOM)

  let materialBezDph = 0
  let sluzbyBezDph = 0
  items.forEach((item) => {
    if (Number(item.TYP_RADKU) === 2) return
    const radekBezDph = toNum(item.POCETMJ) * toNum(item.CENAMJ)
    const typPol = String(item.TYP_POL || '').trim().toUpperCase()
    if (typPol === 'PP' || typPol === 'M' || typPol === 'MAT') materialBezDph += radekBezDph
    else sluzbyBezDph += radekBezDph
  })

  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' })
  const [logoDataUrl, symbolyDataUrl, razitkoDataUrl, bannerPremioDataUrl, energyFuelDataUrl, energyWetDataUrl, energyNoiseDataUrl] = await Promise.all([
    fileUrlToDataUrl(logoImg),
    fileUrlToDataUrl(symbolyImg),
    fileUrlToDataUrl(razitkoImg),
    fileUrlToDataUrl(bannerPremioImg),
    fileUrlToDataUrl(energyFuelImg).then(ensurePdfImageDataUrl).catch(() => ''),
    fileUrlToDataUrl(energyWetImg).then(ensurePdfImageDataUrl).catch(() => ''),
    fileUrlToDataUrl(energyNoiseImg).then(ensurePdfImageDataUrl).catch(() => '')
  ])

  doc.addFileToVFS('Ubuntu-Regular.ttf', toBase64Payload(UbuntuBase64))
  doc.addFont('Ubuntu-Regular.ttf', 'Ubuntu', 'normal')
  doc.addFileToVFS('Ubuntu-Bold.ttf', toBase64Payload(UbuntuBoldBase64))
  doc.addFont('Ubuntu-Bold.ttf', 'Ubuntu', 'bold')

  const pageWidth = doc.internal.pageSize.getWidth()
  const pageHeight = doc.internal.pageSize.getHeight()
  const marginX = 14
  const rightX = 108
  const rightW = pageWidth - rightX - marginX
  doc.setFont('Ubuntu', 'normal')
  doc.setFontSize(8)

  if (logoDataUrl) doc.addImage(logoDataUrl, guessImageFormat(logoDataUrl), marginX, 12, 26, 6)
  const symbolX = pageWidth - marginX - 25
  const symbolY = 12
  doc.setFont('Ubuntu', 'bold')
  doc.setFontSize(8)
  doc.text('Autodíly • Pneu • Servis', symbolX - 2, 15, { align: 'right' })
  doc.text('www.raudo.cz', symbolX - 2, 18, { align: 'right' })
  if (symbolyDataUrl) doc.addImage(symbolyDataUrl, guessImageFormat(symbolyDataUrl), symbolX, symbolY, 25, 7)

  doc.setDrawColor(0)
  doc.rect(marginX, 25, 94, 68)
  doc.setFontSize(8)
  doc.setFont('Ubuntu', 'bold')
  doc.text('Dodavatel', marginX + 3, 30)
  doc.setFont('Ubuntu', 'normal')
  doc.text(`IČ: 26842998`, marginX + 40, 30)
  doc.text(`DIČ: CZ26842998`, marginX + 65, 30)
  doc.text('RAUDO - výrobní družstvo invalidů', marginX + 3, 35)
  const leftBlock = [
    'Uničovská 370/19',
    '787 01  Šumperk',
    '',
    'zapsáno v obch. rejstříku vedeným Krajským soudem v Ostravě,',
    'oddíl Dr., vložka číslo 1797',
    '',    
    'Banka:           ČSOB, a.s. / CEKO CZ PP',
    'Číslo účtu:    214745227 / 0300',
    '',
    `Zakázka:      ${String(header.ZAKAZKA ?? '').trim() === '0' ? '' : (header.ZAKAZKA ?? '')}                        RZ: ${header.SPZ}`,
    `Číslo objednávky:  ${header.CISLOOBJED}               ${header.ORIGCISLO}`,
    `Středisko:    ${String(order?.stredisko || '').trim() || '-'}`,
    '',
  ]
  leftBlock.forEach((line, i) => doc.text(line, marginX + 3, 39 + i * 4))

  doc.setDrawColor(0)
  doc.rect(rightX, 25, rightW, 21)
  doc.setFont('Ubuntu', 'bold')
  doc.setFontSize(11)
  doc.text(`PRODEJKA ZA HOTOVÉ č.: ${header.CISLOPOH || '-'}`, rightX + 3, 32)
  doc.setFontSize(8)
  doc.setFont('Ubuntu', 'normal')
  doc.text(`Ze dne:     ${formatDate(header.DATUM) || '-'}`, rightX + 3, 37)
  doc.text(`Sklad:        ${String(header.SKLAD || '').trim() || ''}`, rightX + 3, 41)

  doc.rect(rightX, 46, rightW, 47)
  doc.setFont('Ubuntu', 'bold')
  doc.setFontSize(8)
  doc.text('Zákazník:', rightX + 3, 51)
  doc.setFont('Ubuntu', 'normal')
  doc.text(`IČO: ${String(header.ICO || '').trim() || '-'}`, rightX + 30, 51)
  doc.text(`DIČ: ${String(header.DIC || '').trim() || '-'}`, rightX + 56, 51)
  doc.setFont('Ubuntu', 'bold')
  doc.setFontSize(9)
  const firma = toTrim(header.FIRMA) || '-'
  const firma2 = toTrim(header.FIRMA2)
  const meno = toTrim(header.MENO)
  const ulica = toTrim(header.ULICA)
  const pscMesto = `${toTrim(header.PSC)}  ${toTrim(header.MESTO)}`.trim()
  const stat = toTrim(header.STAT) || ''
  const addrLines = [firma, firma2, meno, ulica, pscMesto, stat].filter(Boolean)

  doc.text(addrLines[0] || '-', rightX + 3, 58)
  doc.setFont('Ubuntu', 'bold')
  doc.setFontSize(9)
  addrLines.slice(1).forEach((line, idx) => {
    doc.text(line, rightX + 3, 62 + idx * 4)
  })
  doc.setFont('Ubuntu', 'normal')
  doc.setFontSize(8)
  doc.text(`Tel.: ${String(header.TELEFON || '').trim()}`, rightX + 3, 85)
  doc.text(`E-mail: ${String(header.EMAIL || '').trim()}`, rightX + 3, 89)

  let tableStartY = 93
  
  const kpFirma = toTrim(header.KPFIRMA)
  const kpFirma2 = toTrim(header.KPFIRMA2)
  const kpMeno = toTrim(header.KPMENO)
  const kpUlice = toTrim(header.KPULICA)
  const kpPsc = toTrim(header.KPPSC)
  const kpMesto = toTrim(header.KPMESTO)
  const kpStat = toTrim(header.KPSTAT)
  const kpIco = toTrim(header.ICOPRIJ)
  const kpDic = toTrim(header.KPDIC)
  const kpTel = toTrim(header.KPTELEFON)
  const kpEmail = toTrim(header.KPEMAIL)
  const hasFinalRecipient = [kpFirma, kpFirma2, kpMeno, kpUlice, kpPsc, kpMesto, kpStat, kpIco, kpDic, kpTel, kpEmail].some(Boolean)

  if (hasFinalRecipient) {
    const blockTopY = 98
    const contentWidth = pageWidth - (marginX * 2)
    const leftX = marginX + 3
    const rightColX = marginX + 3 + (contentWidth / 2) + 3

    doc.rect(marginX, 93, pageWidth - (marginX * 2), 25)
    doc.setFont('Ubuntu', 'bold')
    doc.setFontSize(8)
    doc.text('Konečný příjemce:', leftX, blockTopY)
    doc.text('Adresa:', rightColX, blockTopY)

    doc.setFont('Ubuntu', 'normal')
    let leftY = blockTopY + 5
    if (kpIco || kpDic) {
      doc.text(`IČO: ${kpIco || '-'}`, leftX, leftY)
      if (kpDic) doc.text(`DIČ: ${kpDic}`, leftX + 42, leftY)
      leftY += 4
    }
    if (kpTel) {
      doc.text(`Tel.: ${kpTel}`, leftX, leftY)
      leftY += 4
    }
    if (kpEmail) {
      doc.text(`E-mail: ${kpEmail}`, leftX, leftY)
      leftY += 4
    }
    const kpPscMesto = `${kpPsc}  ${kpMesto}`.trim()
    const rightLines = [kpFirma, kpFirma2, kpMeno, kpUlice, kpPscMesto, kpStat].filter(Boolean)
    rightLines.forEach((line, idx) => {
      doc.text(line, rightColX, blockTopY + 5 + (idx * 4))
    })
    const leftBottomY = leftY > blockTopY + 5 ? leftY - 1 : blockTopY + 5
    const rightBottomY = rightLines.length ? (blockTopY + 5 + ((rightLines.length - 1) * 4)) : (blockTopY + 5)
    tableStartY = Math.max(leftBottomY, rightBottomY) + 3
  }

  const getItemDiscount = (item) => toNum(item.ZLAVA ?? 0)
  const hasDiscountColumn = items.some((item) => getItemDiscount(item) > 0)
  const tableColCount = hasDiscountColumn ? 8 : 7
  const bodyRows = items.length
    ? items.flatMap((item) => {
      const cleanLine = (value) =>
        String(value || '')
          .replace(/[\r\n\u2028\u2029\t]+/g, ' ')
          .replace(/\u00A0/g, ' ')
          .replace(/\s+/g, ' ')
          .trim()
      const qtyNum = toNum(item.POCETMJ)
      const cenaNum = toNum(item.CENAMJ)
      const sazbaNum = toNum(item.SADZBADPH)
      const slevaNum = getItemDiscount(item)
      const totalWithDph = qtyNum * cenaNum * (1 - slevaNum / 100) * (1 + sazbaNum / 100)
      const cislo = String(item.CISLO || '').replace(/\./g, ',')
      const nazev = cleanLine(item.NAZEV)
      const mj = toTrim(item.MJ)
      const row = [
        cislo,
        nazev,
        mj,
        formatQty(qtyNum),
        formatMoney(cenaNum),
        `${formatPercent(sazbaNum)}`
      ]
      if (hasDiscountColumn) row.push(slevaNum > 0 ? toTrim(`${formatPercent(slevaNum)}`) : '')
      row.push(formatMoney(totalWithDph))
      const rows = [row]

      if (String(item.RECYKLKOD || '').trim().toUpperCase() === 'REC11') {
        const feePerKg = 5.26
        const weightNum = toNum(item.HMOTNOST)
        const recyklPerPiece = feePerKg * weightNum
        const recyklTotal = recyklPerPiece * qtyNum
        const recyklText = `Cena obsahuje příspěvek na recyklaci ${formatMoney(feePerKg)} Kč/kg, při hmotnosti výrobku ${formatQty(weightNum)} kg činí ${formatMoney(recyklPerPiece)} Kč za kus a celkem ${formatMoney(recyklTotal)} Kč.`
        const energyText = `Palivo: ${toTrim(item.USRFLD1) || '-'}    Přilnavost: ${toTrim(item.USRFLD2) || '-'}    Hluk: ${toTrim(item.USRFLD3) || '-'}    Výrobce: ${toTrim(item.KOD1) || '-'}`

        rows.push([
          { content: recyklText, colSpan: tableColCount, styles: { halign: 'left' } }
        ])
        rows.push([
          {
            content: energyText,
            colSpan: tableColCount,
            styles: { halign: 'left' },
            _energyRow: true,
            _energy: {
              fuel: toTrim(item.USRFLD1) || '-',
              wet: toTrim(item.USRFLD2) || '-',
              noise: toTrim(item.USRFLD3) || '-',
              producer: toTrim(item.KOD1) || '-'
            }
          }
        ])
      }

      return rows
    }).filter(Boolean)
    : [hasDiscountColumn ? ['Bez položek', '', '', '', '', '', '', ''] : ['Bez položek', '', '', '', '', '', '']]

  autoTable(doc, {
    startY: tableStartY,
    margin: { left: marginX, right: marginX, top: 22 },
    theme: 'plain',
    head: [hasDiscountColumn
      ? ['Číslo\nkarty', 'Název', 'MJ', 'Počet MJ', 'Cena MJ\nbez DPH', 'DPH\n(%)', 'Sleva\n(%)', 'Celkem (CZK)\ns DPH']
      : ['Číslo\nkarty', 'Název', 'MJ', 'Počet MJ', 'Cena MJ\nbez DPH', 'DPH\n(%)', 'Celkem (CZK)\ns DPH']],
    body: bodyRows,
    styles: {
      font: 'Ubuntu',
      fontSize: 8,
      lineHeight: 1.0,
      minCellHeight: 0,
      cellPadding: { top: 0.75, right: 0.5, bottom: 0.1, left: 0.5 },
      valign: 'top',
      lineColor: 20,
      lineWidth: 0
    },
    headStyles: {
      font: 'Ubuntu',
      fontStyle: 'normal',
      lineHeight: 1.0,
      cellPadding: { top: 0.5, right: 0.7, bottom: 0.5, left: 0.5 },
      halign: 'left',
      lineWidth: { bottom: 0.3 },
      lineColor: 0
    },
    bodyStyles: { lineWidth: 0 },
    didParseCell: (hookData) => {
      const col = hookData.column?.index
      const isNumericCol = hasDiscountColumn
        ? col === 3 || col === 4 || col === 5 || col === 6 || col === 7
        : col === 3 || col === 4 || col === 5 || col === 6
      const isCenterCol = col === 2
      const isFullSpanRow = Number(hookData.cell?.colSpan || 1) >= tableColCount
      const isFirstCol = col === 0 || isFullSpanRow
      const isLastCol = col === (tableColCount - 1) || isFullSpanRow

      const setOuterBorders = () => {
        hookData.cell.styles.lineColor = 0
        hookData.cell.styles.lineWidth = {
          top: 0,
          bottom: hookData.section === 'head' ? 0.3 : 0,
          left: isFirstCol ? 0.2 : 0,
          right: isLastCol ? 0.2 : 0,
        }
      }

      if (hookData.section === 'head') {
        if (isCenterCol) hookData.cell.styles.halign = 'center'
        else if (isNumericCol) hookData.cell.styles.halign = 'right'
        else hookData.cell.styles.halign = 'left'
        setOuterBorders()
        return
      }
      if (hookData.section !== 'body') return
      hookData.cell.styles.minCellHeight = 0
      hookData.cell.styles.lineHeight = 0.9
      hookData.cell.styles.cellPadding = { top: 0.75, right: 0.5, bottom: 0.1, left: 0.5 }
      if (hookData.column?.index === 0 && hookData.cell?.raw?._energyRow) {
        hookData.cell.styles.minCellHeight = 4.8
        if (energyFuelDataUrl && energyWetDataUrl && energyNoiseDataUrl) {
          hookData.cell.text = ['']
        }
      }
      if (isCenterCol) hookData.cell.styles.halign = 'center'
      else if (isNumericCol) hookData.cell.styles.halign = 'right'
      else hookData.cell.styles.halign = 'left'
      setOuterBorders()
    },
    didDrawCell: (hookData) => {
      if (hookData.section !== 'body' || hookData.column?.index !== 0) return
      const raw = hookData.cell?.raw
      if (!raw?._energyRow || !raw?._energy) return
      if (!energyFuelDataUrl || !energyWetDataUrl || !energyNoiseDataUrl) return

      const iconW = 3.6
      const iconH = 3.6
      const centerY = hookData.cell.y + (hookData.cell.height / 2) - (iconH / 2)
      const baseX = hookData.cell.x + 0.8
      const textY = hookData.cell.y + (hookData.cell.height / 2) + 1
      const docRef = hookData.doc

      docRef.addImage(energyFuelDataUrl, guessImageFormat(energyFuelDataUrl), baseX, centerY, iconW, iconH)
      docRef.text(String(raw._energy.fuel || '-'), baseX + 5.2, textY)
      docRef.addImage(energyWetDataUrl, guessImageFormat(energyWetDataUrl), baseX + 16.5, centerY, iconW, iconH)
      docRef.text(String(raw._energy.wet || '-'), baseX + 21.7, textY)
      docRef.addImage(energyNoiseDataUrl, guessImageFormat(energyNoiseDataUrl), baseX + 29.7, centerY, iconW, iconH)
      docRef.text(`${String(raw._energy.noise || '-')}`, baseX + 34.9, textY)
      docRef.text(`Výrobce: ${String(raw._energy.producer || '-')}`, baseX + 49.8, textY)
    },
    columnStyles: hasDiscountColumn
      ? {
          0: { cellWidth: 18 },
          1: { cellWidth: 72 },
          2: { cellWidth: 10, halign: 'center' },
          3: { cellWidth: 18, halign: 'right' },
          4: { cellWidth: 20, halign: 'right' },
          5: { cellWidth: 12, halign: 'right' },
          6: { cellWidth: 12, halign: 'right' },
          7: { cellWidth: 20, halign: 'right' }
        }
      : {
          0: { cellWidth: 18 },
          1: { cellWidth: 84 },
          2: { cellWidth: 10, halign: 'center' },
          3: { cellWidth: 18, halign: 'right' },
          4: { cellWidth: 20, halign: 'right' },
          5: { cellWidth: 12, halign: 'right' },
          6: { cellWidth: 20, halign: 'right' }
        }
  })

  const afterTableY = doc.lastAutoTable?.finalY
  doc.setLineWidth(0.25)
  doc.line(marginX, afterTableY + 0.1, pageWidth - marginX, afterTableY + 0.1)

  const summaryBlockHeight = 31
  const footerBlockHeight = 40
  const bottomSafeMargin = 14
  const contentLimitY = pageHeight - bottomSafeMargin
  const summaryStartCandidate = afterTableY + 5
  const canRenderSummaryOnCurrentPage =
    (summaryStartCandidate + summaryBlockHeight) <= contentLimitY
  if (!canRenderSummaryOnCurrentPage) {
    doc.addPage()
  }
  const summaryY = canRenderSummaryOnCurrentPage ? summaryStartCandidate : 40
  const zakl2 = toNum(header.ZAKL2)
  const zakl1 = toNum(header.ZAKL1)
  const zakl0 = toNum(header.ZAKL0)
  const dph2 = toNum(header.DPH2)
  const dph1 = toNum(header.DPH1)
  const celk2 = zakl2 + dph2
  const celk1 = zakl1 + dph1

  const c4 = pageWidth - marginX
  const c3 = c4 - 25
  const c2 = c3 - 22
  const c1 = c2 - 47

  doc.setFont('Ubuntu', 'bold')
  doc.setFontSize(8)
  doc.text('Rekapitulace', c1, summaryY)
  doc.setFont('Ubuntu', 'normal')
  doc.text('Celkem bez DPH', c2, summaryY, { align: 'right' })
  doc.text('Částka DPH', c3, summaryY, { align: 'right' })
  doc.text('Celkem s DPH', c4, summaryY, { align: 'right' })
  doc.line(c1, summaryY + 1, c4, summaryY + 1)

  doc.text('V sazbě základní', c1, summaryY + 5)
  doc.text(formatMoney(zakl2), c2, summaryY + 5, { align: 'right' })
  doc.text(formatMoney(dph2), c3, summaryY + 5, { align: 'right' })
  doc.text(formatMoney(celk2), c4, summaryY + 5, { align: 'right' })

  doc.text('V sazbě snížené', c1, summaryY + 9)
  doc.text(formatMoney(zakl1), c2, summaryY + 9, { align: 'right' })
  doc.text(formatMoney(dph1), c3, summaryY + 9, { align: 'right' })
  doc.text(formatMoney(celk1), c4, summaryY + 9, { align: 'right' })

  doc.text('Mimo DPH', c1, summaryY + 13)
  doc.text(formatMoney(zakl0), c2, summaryY + 13, { align: 'right' })
  doc.text('', c3, summaryY + 13, { align: 'right' })
  doc.text(formatMoney(zakl0), c4, summaryY + 13, { align: 'right' })

  doc.text('Součet', c1, summaryY + 18)
  doc.text(formatMoney(zaklad), c2, summaryY + 18, { align: 'right' })
  doc.text(formatMoney(dph), c3, summaryY + 18, { align: 'right' })
  doc.text(formatMoney(celkem), c4, summaryY + 18, { align: 'right' })
  doc.line(c1, summaryY + 20, c4, summaryY + 20)

  doc.setFont('Ubuntu', 'bold')
  doc.setFontSize(9)
  doc.text('Celkem k úhradě (Kč)', c3 - 8, summaryY + 25, { align: 'right' })
  doc.text(formatMoney(celkem), c4, summaryY + 25, { align: 'right' })

  let contentEndY = summaryY + 31
  const poznamkaRaw = String(header.POZNAMKA ?? '').replace(/\r\n/g, '\n').trim()
  if (poznamkaRaw) {
    const noteTopGap = 8
    const noteLineHeight = 4
    const noteMaxWidth = pageWidth - (marginX * 2)
    const noteLines = doc.splitTextToSize(poznamkaRaw, noteMaxWidth)
    const noteBlockHeight = noteTopGap + 4 + (noteLines.length * noteLineHeight) 
    if ((contentEndY + noteBlockHeight) > contentLimitY) {
      doc.addPage()
      contentEndY = 30
    }
    const noteY = contentEndY + noteTopGap
    doc.setFont('Ubuntu', 'normal')
    doc.setFontSize(8)
    doc.text('Poznámka:', marginX, noteY)    
    doc.text(noteLines, marginX, noteY + 4)
    contentEndY = noteY + 4 + (noteLines.length * noteLineHeight)
  }

  // Blok poděkování pod rekapitulací (vlevo)
  const thanksBlockHeight = 30
  if ((contentEndY + 6 + thanksBlockHeight) > contentLimitY) {
    doc.addPage()
    contentEndY = 30
  }
  const thanksY = contentEndY + 6
  const stampX = marginX + 45
  const stampY = thanksY + 3
  const stampW = 45
  const stampH = 20
  doc.setFont('Ubuntu', 'normal')
  doc.setFontSize(8)
  doc.text('Děkujeme za Váš nákup.', marginX, thanksY)
  if (razitkoDataUrl) {
    doc.addImage(razitkoDataUrl, guessImageFormat(razitkoDataUrl), stampX, stampY, stampW, stampH)
  }
  doc.text(`Dne: ${formatDate(new Date()) || '-'}`, marginX, thanksY + 25)
  doc.setLineDashPattern([1, 1], 0)
  doc.line(stampX, thanksY + 26, stampX + stampW, thanksY + 26)
  doc.setLineDashPattern([], 0)
  doc.text('Doklad Vystavil (podpis, razítko)', marginX, thanksY + 30)
  contentEndY = thanksY + 30

  const footerStartY = contentEndY + 6
  const needsNewPage = (footerStartY + footerBlockHeight) > (pageHeight - bottomSafeMargin)
  if (needsNewPage) doc.addPage()

  const totalPages = doc.getNumberOfPages()
  for (let page = 1; page <= totalPages; page += 1) {
    doc.setPage(page)
    if (page === 1) {
      doc.setFont('Ubuntu', 'normal')
      doc.setFontSize(8)
      doc.text(`Strana ${page} / ${totalPages}`, marginX + 3, 89)
      continue
    }
    doc.setFont('Ubuntu', 'bold')
    doc.setFontSize(10)
    doc.text(`Prodejka za hotové č. ${header.CISLOPOH || '-'} (pokračování)`, marginX, 14)
    doc.setFont('Ubuntu', 'normal')
    doc.setFontSize(8)
    doc.text(`Strana ${page} / ${totalPages}`, pageWidth - marginX, 14, { align: 'right' })
    doc.setLineWidth(0.25)
    doc.line(marginX - 1, 17, pageWidth - marginX, 17)
  }

  doc.setPage(totalPages)
  const fy = pageHeight - bottomSafeMargin - footerBlockHeight
  const fw = pageWidth - (marginX * 2)
  doc.setLineWidth(0.25)
  doc.line(marginX, fy, marginX + fw, fy)
  doc.setFont('Ubuntu', 'bold')
  doc.setFontSize(10)
  doc.text('INFORMACE ZÁKAZNÍKŮM', pageWidth / 2, fy + 5, { align: 'center' })
  doc.line(marginX, fy + 8, marginX + fw, fy + 8)

  doc.setFont('Ubuntu', 'normal')
  doc.setFontSize(8)
  const infoText = 'Důležité upozornění! V případě výměny pneumatiky na vozidle proveďte po ujetí 20 km kontrolu dotažení šroubů kol. U zboží, které byste chtěli případně vrátit z jiných než kvalitativních důvodů bude účtován poplatek za vrácení zboží. Bez dokladu o sezónní úschově nelze pneumatiky vydat zpět. Tento doklad si uschovejte pro případnou reklamaci. Za obal byl pod identifikačním číslem EK-F00110247 uhrazen poplatek za zajištění zpětného odběru a využití obalového odpadu společnosti EKO-KOM, a.s.'
  const infoWrapped = doc.splitTextToSize(infoText, fw - 2)
  doc.text(infoWrapped, marginX, fy + 12)

  const promoY = fy + 24
  const promoH = 11
  if (bannerPremioDataUrl) {
    doc.addImage(bannerPremioDataUrl, guessImageFormat(bannerPremioDataUrl), marginX, promoY, fw, promoH)
  } else {
    doc.rect(marginX, promoY, fw, promoH)
  }
  
  doc.setFont('Ubuntu', 'normal')
  doc.setFontSize(8)
  doc.text('#UC110194-50, program firmy © MRP - Informatics, s.r.o., P.O.BOX 35, 763 15 Slušovice', marginX, fy + 40)
  
  doc.autoPrint()
  const blobUrl = doc.output('bloburl')
  if (typeof window !== 'undefined') window.open(blobUrl, '_blank', 'noopener,noreferrer')
}

const OrdersSalePrintTrigger = ({ order, disabled = false, onError, renderButton }) => {
  const handleClick = async (event) => {
    event?.stopPropagation?.()
    if (disabled) return
    try {
      await printSale(order)
    } catch (error) {
      onError?.(error)
    }
  }

  if (typeof renderButton === 'function') {
    return renderButton({ onClick: handleClick, disabled })
  }

  return (
    <button type="button" onClick={handleClick} disabled={disabled}>
      Tisk
    </button>
  )
}

export default OrdersSalePrintTrigger
